import React, { useState } from 'react';
import { Select, MenuItem, Chip, ListSubheader, Box } from '@mui/material';
import { PIPELINE_STAGES, getStageForStatus } from './pipelineConfig';

const InlineStatusSelect = ({ leadId, currentStatus, onStatusChange }) => {
  const [isEditing, setIsEditing] = useState(false);
  const stage = getStageForStatus(currentStatus || 'New');

  const handleChange = (event) => {
    const newStatus = event.target.value;
    if (newStatus !== currentStatus) {
      const targetStage = getStageForStatus(newStatus);
      onStatusChange({
        leadId,
        newStatus,
        sourceStage: stage,
        targetStage,
      });
    }
    setIsEditing(false);
  };

  if (!isEditing) {
    return (
      <Chip
        label={currentStatus || 'New'}
        size="small"
        onClick={(e) => {
          e.stopPropagation();
          setIsEditing(true);
        }}
        sx={{
          bgcolor: `${stage.color}18`,
          color: stage.color,
          fontWeight: 600,
          fontSize: '0.7rem',
          cursor: 'pointer',
          borderColor: stage.color,
          '&:hover': {
            bgcolor: `${stage.color}30`,
          },
        }}
        variant="outlined"
      />
    );
  }

  return (
    <Select
      value={currentStatus || 'New'}
      onChange={handleChange}
      onClose={() => setIsEditing(false)}
      size="small"
      autoFocus
      open
      sx={{
        fontSize: '0.75rem',
        minWidth: 140,
        '.MuiSelect-select': { py: 0.5 },
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {PIPELINE_STAGES.map((pStage) => [
        <ListSubheader
          key={`header-${pStage.id}`}
          sx={{
            fontWeight: 700,
            fontSize: '0.7rem',
            color: pStage.color,
            lineHeight: '28px',
            bgcolor: 'background.paper',
          }}
        >
          <Box display="flex" alignItems="center" gap={0.5}>
            <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: pStage.color }} />
            {pStage.label}
          </Box>
        </ListSubheader>,
        ...pStage.statuses.map((status) => (
          <MenuItem key={status} value={status} sx={{ fontSize: '0.75rem', pl: 4 }}>
            {status}
          </MenuItem>
        )),
      ])}
    </Select>
  );
};

export default InlineStatusSelect;
